import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: 'oklch(var(--background-900))' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-2xl" style={{ color: 'oklch(var(--primary-400))' }}></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-200">性事咨询员</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              专业、私密、温暖的两性健康咨询服务平台。
              <br />
              由持证专业顾问团队提供一对一陪伴式咨询服务，
              <br />
              帮助您重建自信与和谐的亲密生活。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-200 mb-4">服务分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-200 mb-4">联系我们</h4>
            <div className="space-y-3 text-sm text-background-400">
              <p>服务时间：周一至周日 9:00 - 21:00</p>
              <p>咨询热线：400-888-XXXX</p>
              <p>电子邮箱：hello@xingshizixun.com</p>
              <div className="flex items-center gap-4 pt-2">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 text-background-300 hover:text-background-50 transition-all duration-200" aria-label="电话" rel="nofollow">
                  <i className="ri-phone-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ borderTop: '1px solid oklch(var(--background-700) / 0.4)' }}>
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 性事咨询员. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</Link>
            <Link to="/about#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}